import { List, ListProps } from '@chakra-ui/react'

export type { ListProps }

export default List
